/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./themeColor.vue?vue&type=template&id=ad95c560&scoped=true&"
import script from "./themeColor.vue?vue&type=script&lang=js&"
export * from "./themeColor.vue?vue&type=script&lang=js&"
import style0 from "./themeColor.vue?vue&type=style&index=0&id=ad95c560&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad95c560",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCol,VColorPicker,VRow})
